<template>
  <div v-if="showBanner" class="cookie-banner" dir="rtl">
    <div class="cookie-content">
      <h4>הודעה על שימוש בעוגיות</h4>
      <p>אתר זה משתמש בעוגיות כדי לשפר את חוויית הגלישה שלך ולאסוף נתונים סטטיסטיים. העוגיות כוללות Google Analytics ו-Google Tag Manager לצורך ניתוח תנועה באתר.</p>
      <div class="cookie-buttons">
        <button @click="acceptAll" class="btn-accept">קבל הכל</button>
        <button @click="rejectAll" class="btn-reject">דחה הכל</button>
        <button @click="showSettings = true" class="btn-settings">הגדרות מתקדמות</button>
      </div>
    </div>
    
    <div v-if="showSettings" class="cookie-settings">
      <h5>הגדרות עוגיות</h5>
      <div class="cookie-category">
        <label>
          <input type="checkbox" v-model="preferences.necessary" disabled checked>
          עוגיות הכרחיות (חובה)
        </label>
        <p>עוגיות הדרושות לתפקוד בסיסי של האתר</p>
      </div>
      <div class="cookie-category">
        <label>
          <input type="checkbox" v-model="preferences.analytics">
          עוגיות אנליטיות
        </label>
        <p>Google Analytics לניתוח תנועה באתר</p>
      </div>
      <div class="cookie-category">
        <label>
          <input type="checkbox" v-model="preferences.marketing">
          עוגיות שיווק
        </label>
        <p>Google Tag Manager לצורך מעקב ושיווק</p>
      </div>
      <div class="settings-buttons">
        <button @click="savePreferences" class="btn-save">שמור העדפות</button>
        <button @click="showSettings = false" class="btn-cancel">ביטול</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: false,
      showSettings: false,
      preferences: {
        necessary: true,
        analytics: false,
        marketing: false
      }
    }
  },
  mounted() {
    this.checkConsent()
  },
  methods: {
    checkConsent() {
      const consent = localStorage.getItem('cookieConsent')
      if (!consent) {
        this.showBanner = true
      } else {
        const savedPrefs = JSON.parse(consent)
        this.loadScripts(savedPrefs)
      }
    },
    acceptAll() {
      const consent = {
        necessary: true,
        analytics: true,
        marketing: true,
        timestamp: new Date().toISOString()
      }
      this.saveConsent(consent)
      this.loadScripts(consent)
      this.showBanner = false
    },
    rejectAll() {
      const consent = {
        necessary: true,
        analytics: false,
        marketing: false,
        timestamp: new Date().toISOString()
      }
      this.saveConsent(consent)
      this.showBanner = false
    },
    savePreferences() {
      const consent = {
        ...this.preferences,
        timestamp: new Date().toISOString()
      }
      this.saveConsent(consent)
      this.loadScripts(consent)
      this.showBanner = false
      this.showSettings = false
    },
    saveConsent(consent) {
      localStorage.setItem('cookieConsent', JSON.stringify(consent))
    },
    loadScripts(consent) {
      if (consent.analytics) {
        this.loadGoogleAnalytics()
      }
      if (consent.marketing) {
        this.loadGoogleTagManager()
      }
    },
    loadGoogleAnalytics() {
      if (!window.gtag) {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MX1L21G575'
        document.head.appendChild(script)
        
        script.onload = () => {
          window.dataLayer = window.dataLayer || []
          function gtag(){dataLayer.push(arguments)}
          window.gtag = gtag
          gtag('js', new Date())
          gtag('config', 'G-MX1L21G575')
        }
      }
    },
    loadGoogleTagManager() {
      if (!window.google_tag_manager) {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-WK5DGS')
      }
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2c3e50;
  color: white;
  padding: 20px;
  z-index: 10000;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
}

.cookie-content h4 {
  margin: 0 0 10px 0;
  font-size: 18px;
}

.cookie-content p {
  margin: 0 0 15px 0;
  line-height: 1.5;
}

.cookie-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.cookie-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}

.btn-accept {
  background: #27ae60;
  color: white;
}

.btn-reject {
  background: #e74c3c;
  color: white;
}

.btn-settings {
  background: #3498db;
  color: white;
}

.cookie-settings {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #34495e;
}

.cookie-category {
  margin: 15px 0;
}

.cookie-category label {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-bottom: 5px;
}

.cookie-category input {
  margin-left: 10px;
}

.cookie-category p {
  margin: 5px 0 0 25px;
  font-size: 14px;
  color: #bdc3c7;
}

.settings-buttons {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.btn-save {
  background: #27ae60;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-cancel {
  background: #95a5a6;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .cookie-banner {
    padding: 15px;
  }
  
  .cookie-buttons {
    flex-direction: column;
  }
  
  .cookie-buttons button {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>